const VALIDATION_MESSAGES = {
  "preTestSpillageOpenDoorOnlyOne": "Please only select one option for draft and spillage results.",
  "preTestSpillageOpenDoor2OnlyOne": "Please only select one option for draft and spillage results.",
  "preTestSpillageClosedDoorOnlyOne": "Please only select one option for draft and spillage results.",
  "preTestSpillageClosedDoor2OnlyOne": "Please only select one option for draft and spillage results.",
  "preTestDraftOpenDoorOnlyOne": "Please only select one option for draft and draft results.",
  "preTestDraftOpenDoor2OnlyOne": "Please only select one option for draft and draft results.",
  "preTestDraftClosedDoorOnlyOne": "Please only select one option for draft and draft results.",
  "preTestDraftClosedDoor2OnlyOne": "Please only select one option for draft and draft results.",
  "postTestSpillageOpenDoorOnlyOne": "Please only select one option for draft and spillage results.",
  "postTestSpillageOpenDoor2OnlyOne": "Please only select one option for draft and spillage results.",
  "postTestSpillageClosedDoorOnlyOne": "Please only select one option for draft and spillage results.",
  "postTestSpillageClosedDoor2OnlyOne": "Please only select one option for draft and spillage results.",
  "postTestDraftOpenDoorOnlyOne": "Please only select one option for draft and draft results.",
  "postTestDraftOpenDoor2OnlyOne": "Please only select one option for draft and draft results.",
  "postTestDraftClosedDoorOnlyOne": "Please only select one option for draft and draft results.",
  "postTestDraftClosedDoor2OnlyOne": "Please only select one option for draft and draft results.",
  "pretestPrimarySelectYesOrNo_1": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_2": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_3": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_4": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_5": "Please select only yes or no.",
  "pretestPrimarySelectYesOrNo_6": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_1": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_2": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_3": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_4": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_5": "Please select only yes or no.",
  "pretestSecondarySelectYesOrNo_6": "Please select only yes or no.",
  "postTestPrimarySelectYesOrNo_1": "Please select only yes or no.",
  "postTestPrimarySelectYesOrNo_3": "Please select only yes or no.",
  "postTestPrimarySelectYesOrNo_4": "Please select only yes or no.",
  "postTestPrimarySelectYesOrNo_6": "Please select only yes or no.",
  "postTestSecondarySelectYesOrNo_1": "Please select only yes or no.",
  "postTestSecondarySelectYesOrNo_3": "Please select only yes or no.",
  "postTestSecondarySelectYesOrNo_4": "Please select only yes or no.",
  "postTestSecondarySelectYesOrNo_6": "Please select only yes or no.",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "preTestSpillageOpenDoor_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageOpenDoor_pass", "preTestSpillageOpenDoor_fail", "preTestSpillageOpenDoor_nf", "preTestSpillageOpenDoor_hazard", "preTestSpillageOpenDoor_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageOpenDoorOnlyOne'];
      },
    }),
    "preTestSpillageOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageOpenDoor2_pass", "preTestSpillageOpenDoor2_fail", "preTestSpillageOpenDoor2_nf", "preTestSpillageOpenDoor2_hazard", "preTestSpillageOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageOpenDoor2OnlyOne'];
      },
    }),
    "preTestSpillageClosedDoor_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageClosedDoor_pass", "preTestSpillageClosedDoor_fail", "preTestSpillageClosedDoor_nf", "preTestSpillageClosedDoor_hazard", "preTestSpillageClosedDoor_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageClosedDoorOnlyOne'];
      },
    }),
    "preTestSpillageClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestSpillageClosedDoor2_pass", "preTestSpillageClosedDoor2_fail", "preTestSpillageClosedDoor2_nf", "preTestSpillageClosedDoor2_hazard", "preTestSpillageClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestSpillageClosedDoor2OnlyOne'];
      },
    }),
    "preTestDraftOpenDoor1_pass": () => ({
      validate: () => {
        const options = ["preTestDraftOpenDoor1_pass", "preTestDraftOpenDoor1_fail", "preTestDraftOpenDoor1_nf", "preTestDraftOpenDoor1_hazard", "preTestDraftOpenDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftOpenDoorOnlyOne'];
      },
    }),
    "preTestDraftOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestDraftOpenDoor2_pass", "preTestDraftOpenDoor2_fail", "preTestDraftOpenDoor2_nf", "preTestDraftOpenDoor2_hazard", "preTestDraftOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftOpenDoor2OnlyOne'];
      },
    }),
    "preTestDraftClosedDoor1_pass": () => ({
      validate: () => {
        const options = ["preTestDraftClosedDoor1_pass", "preTestDraftClosedDoor1_fail", "preTestDraftClosedDoor1_nf", "preTestDraftClosedDoor1_hazard", "preTestDraftClosedDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftClosedDoorOnlyOne'];
      },
    }),
    "preTestDraftClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["preTestDraftClosedDoor2_pass", "preTestDraftClosedDoor2_fail", "preTestDraftClosedDoor2_nf", "preTestDraftClosedDoor2_hazard", "preTestDraftClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftClosedDoor2OnlyOne'];
      },
    }),
    "postTestSpillageOpenDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageOpenDoor1_pass", "postTestSpillageOpenDoor1_fail", "postTestSpillageOpenDoor1_nf", "postTestSpillageOpenDoor1_hazard", "postTestSpillageOpenDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageOpenDoorOnlyOne'];
      },
    }),
    "postTestSpillageOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageOpenDoor2_pass", "postTestSpillageOpenDoor2_fail", "postTestSpillageOpenDoor2_nf", "postTestSpillageOpenDoor2_hazard", "postTestSpillageOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageOpenDoor2OnlyOne'];
      },
    }),
    "postTestSpillageClosedDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageClosedDoor1_pass", "postTestSpillageClosedDoor1_fail", "postTestSpillageClosedDoor1_nf", "postTestSpillageClosedDoor1_hazard", "postTestSpillageClosedDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageClosedDoorOnlyOne'];
      },
    }),
    "postTestSpillageClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestSpillageClosedDoor2_pass", "postTestSpillageClosedDoor2_fail", "postTestSpillageClosedDoor2_nf", "postTestSpillageClosedDoor2_hazard", "postTestSpillageClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSpillageClosedDoor2OnlyOne'];
      },
    }),
    "postTestDraftOpenDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestDraftOpenDoor1_pass", "postTestDraftOpenDoor1_fail", "postTestDraftOpenDoor1_nf", "postTestDraftOpenDoor1_hazard", "postTestDraftOpenDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftOpenDoorOnlyOne'];
      },
    }),
    "postTestDraftOpenDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestDraftOpenDoor2_pass", "postTestDraftOpenDoor2_fail", "postTestDraftOpenDoor2_nf", "postTestDraftOpenDoor2_hazard", "postTestDraftOpenDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftOpenDoor2OnlyOne'];
      },
    }),
    "postTestDraftClosedDoor1_pass": () => ({
      validate: () => {
        const options = ["postTestDraftClosedDoor1_pass", "postTestDraftClosedDoor1_fail", "postTestDraftClosedDoor1_nf", "postTestDraftClosedDoor1_hazard", "postTestDraftClosedDoor1_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftClosedDoorOnlyOne'];
      },
    }),
    "postTestDraftClosedDoor2_pass": () => ({
      validate: () => {
        const options = ["postTestDraftClosedDoor2_pass", "postTestDraftClosedDoor2_fail", "postTestDraftClosedDoor2_nf", "postTestDraftClosedDoor2_hazard", "postTestDraftClosedDoor2_na"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftClosedDoor2OnlyOne'];
      },
    }),
    "preTestConditionsPrimary1_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsPrimary1_yes", "preTestConditionsPrimary1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_1'];
      },
    }),
    "preTestConditionsPrimary2_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsPrimary2_yes", "preTestConditionsPrimary2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_2'];
      },
    }),
    "preTestConditionsPrimary3_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsPrimary3_yes", "preTestConditionsPrimary3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_3'];
      },
    }),
    "preTestConditionsPrimary4_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsPrimary4_yes", "preTestConditionsPrimary4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_4'];
      },
    }),
    "preTestConditionsPrimary5_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsPrimary5_yes", "preTestConditionsPrimary5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_5'];
      },
    }),
    "preTestConditionsPrimary6_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsPrimary6_yes", "preTestConditionsPrimary6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestPrimarySelectYesOrNo_6'];
      },
    }),
    "preTestConditionsSecondary1_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsSecondary1_yes", "preTestConditionsSecondary1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_1'];
      },
    }),
    "preTestConditionsSecondary2_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsSecondary2_yes", "preTestConditionsSecondary2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_2'];
      },
    }),
    "preTestConditionsSecondary3_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsSecondary3_yes", "preTestConditionsSecondary3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_3'];
      },
    }),
    "preTestConditionsSecondary4_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsSecondary4_yes", "preTestConditionsSecondary4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_4'];
      },
    }),
    "preTestConditionsSecondary5_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsSecondary5_yes", "preTestConditionsSecondary5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_5'];
      },
    }),
    "preTestConditionsSecondary6_yes": () => ({
      validate: () => {
        const yesOrNo = ["preTestConditionsSecondary6_yes", "preTestConditionsSecondary6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['pretestSecondarySelectYesOrNo_6'];
      },
    }),
    "postTestConditionsPrimary1_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsPrimary1_yes", "postTestConditionsPrimary1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimarySelectYesOrNo_1'];
      },
    }),
    "postTestConditionsPrimary3_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsPrimary3_yes", "postTestConditionsPrimary3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimarySelectYesOrNo_3'];
      },
    }),
    "postTestConditionsPrimary4_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsPrimary4_yes", "postTestConditionsPrimary4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimarySelectYesOrNo_4'];
      },
    }),
    "postTestConditionsPrimary6_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsPrimary6_yes", "postTestConditionsPrimary6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestPrimarySelectYesOrNo_6'];
      },
    }),
    "postTestConditionsSecondary1_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsSecondary1_yes", "postTestConditionsSecondary1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSecondarySelectYesOrNo_1'];
      },
    }),
    "postTestConditionsSecondary3_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsSecondary3_yes", "postTestConditionsSecondary3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSecondarySelectYesOrNo_3'];
      },
    }),
    "postTestConditionsSecondary4_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsSecondary4_yes", "postTestConditionsSecondary4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSecondarySelectYesOrNo_4'];
      },
    }),
    "postTestConditionsSecondary6_yes": () => ({
      validate: () => {
        const yesOrNo = ["postTestConditionsSecondary6_yes", "postTestConditionsSecondary6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestSecondarySelectYesOrNo_6'];
      },
    }),
  };
};

export default useValidation;
